import { Colors, Typography } from '~/styles';
import type { TStyleSheet } from '~/types/emotion-styles';

const styles: TStyleSheet = {
  text: {
    ...Typography.bodyLarge,
    color: Colors.white,
  },
};

export default styles;
